module.exports = __webpack_public_path__ + "static/media/troubleshooting-icon.54bc61e3.png";